const React = require('react');
const ReactDOM = require('react-dom');

const Magnifier = require('./Magnifier.jsx');

const ImageMagnifier = React.createClass({
  propTypes: {
    // the size of the magnifier window
    size: React.PropTypes.number,

    // source and native dimensions of image
    image: React.PropTypes.shape({
      src: React.PropTypes.string.isRequired,
      nativeWidth: React.PropTypes.number.isRequired,
      nativeHeight: React.PropTypes.number.isRequired,
      alt: React.PropTypes.string.isRequired
    }).isRequired
  },

  getDefaultProps() {
    return {
      size: 200
    };
  },

  getInitialState() {
    return {
      mouseX: 0,
      mouseY: 0,
      imageRect: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    };
  },

  portalElement: null,

  componentDidMount() {
    document.addEventListener('mousemove', this.onMouseMove);

    if (!this.portalElement) {
      this.portalElement = document.createElement('div');
      document.body.appendChild(this.portalElement);
    }

    this.componentDidUpdate();
  },

  componentDidUpdate() {
    ReactDOM.render(
      <Magnifier
        size={this.props.size}
        image={this.props.image}
        imageRect={this.state.imageRect}
        mouseX={this.state.mouseX}
        mouseY={this.state.mouseY} />, 
      this.portalElement
    );
  },

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.body.removeChild(this.portalElement);
    this.portalElement = null;
  },

  onMouseMove(e) {
    let imageRect = ReactDOM.findDOMNode(this).firstChild.getBoundingClientRect();

    this.setState({
        mouseX: e.clientX,
        mouseY: e.clientY,
        imageRect: imageRect
    });
  },

  render() {
    return (
      <div className='uc-image-magnifier'>
        <img
          alt={this.props.image.alt}
          size={this.props.size}
          src={this.props.image.src}
          onLoad={this.props.onLoad} />
      </div>
    );
  }
});

module.exports = ImageMagnifier;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/ImageMagnifier.jsx